'use client'

// src/utils/utm.ts
import { getItem, safeParseJson } from "@wbk/utils";
var getAnalyticsUtms = () => {
  if (typeof window !== "undefined") {
    const search = new URLSearchParams(window.location.search);
    const utm_wbk_wa_session_id = getItem("utm_wbk_wa_session_id");
    const allParams = {
      utm_wbk_wa_session_id: utm_wbk_wa_session_id || ""
    };
    search.forEach((value, key) => {
      allParams[key] = value;
    });
    return Object.keys(allParams).length > 0 ? allParams : void 0;
  }
};
var getAnalyticsUtmsFromStorage = () => {
  if (typeof window !== "undefined") {
    const savedUtms = getItem("utms");
    return savedUtms ? safeParseJson(savedUtms) : null;
  }
};

export {
  getAnalyticsUtms,
  getAnalyticsUtmsFromStorage
};
//# sourceMappingURL=chunk-DU4OPONN.mjs.map